<template>
  <div class="text-surface-foreground flex items-center pl-4 pt-4 pb-4 lg:pl-0 **:text-sm">
    <span v-for="(node, i) of path" :key="i" class="flex h-8 items-center">
      <HomeIcon v-if="i == 0" class="size-4 mr-1" />
      <ChevronRightIcon v-if="i" class="w-6 h-6" />
      <span class="flex">
        <RouterLink v-if="node.to" :to="node.to" class="hover:underline text-base">{{
          $t(label(node.label))
        }}</RouterLink>
        <span v-else class="text-base">{{ $t(node.label) }}</span>
      </span>
    </span>
  </div>
</template>
<script setup lang="ts">
import { ChevronRightIcon } from "@heroicons/vue/20/solid";
import HomeIcon from "~icons/ic/round-home";

const { path } = defineProps<{
  path: Array<{
    label: string;
    to?: string | Record<string, unknown>;
  }>;
}>();

const label = (nodeLabel) => {
  return nodeLabel === "Nfl" ? "NFL" : nodeLabel;
};
</script>
